import { Component, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

export interface DialogData {
  paymentMethod: string,
  property_id: string,
  transaction_id: string,
  amount: number,
  image: any,
  voucherPath: any
}


@Component({
  selector: 'app-bank-transfer',
  templateUrl: './bank-transfer.component.html',
  styleUrls: ['./bank-transfer.component.css']
})
export class BankTransferComponent {

  basicInfoForm: FormGroup = new FormGroup({
    paymentMethod: new FormControl('', [Validators.required]),
    property_id: new FormControl('', [Validators.required]),
    transaction_id: new FormControl('', [Validators.required]),
    amount: new FormControl('', [Validators.required]),
    voucherPath: new FormControl('')
  })

  imgURL: any

  constructor(
    public dialogRef: MatDialogRef<BankTransferComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
      this.imgURL = data.image
      delete data['image']
      this.basicInfoForm.setValue(data)
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  fileChangeEvent(event: any){
    let image = event.target.files[0]
    var filesize = Math.ceil((parseInt(image.size)/1024)/1024)
    if(filesize <= 8){
      this.basicInfoForm['controls']['voucherPath'].setValue(image)
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); 
      reader.onload = (_event) => { 
        this.imgURL = reader.result; 
      }
    }
  }

  saveBankDepositInfo(){
    if(this.basicInfoForm.valid){
      let basicInfo = this.basicInfoForm.value
      this.dialogRef.close(basicInfo)
    }
  }

}

